'use client';

import { css, cx } from '@onbeam/business-styled-system/css';
import { flex, vstack } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import { Popover } from '@/components/shared/Popover';
import { MenuItem } from '@/components/shared/Menu';
import { mobileNavItems } from './MobileNavigationButton.utils';
import { ArrowRightIcon } from '@onbeam/icons/business';
import { useBreakpoint } from '@onbeam/utils';

export const MobileNavigationButton = () => {
  const isSmallMobile = useBreakpoint({ max: '26.25rem' });

  return (
    <Popover
      trigger={
        <Button
          size={isSmallMobile ? 'sm' : 'md'}
          className={css({ whiteSpace: 'nowrap' })}
        >
          Get involved
        </Button>
      }
      align="end"
      sideOffset={0}
      className={cx(
        'dark',
        vstack({
          bg: 'mono.primaryFg',
          color: 'mono.primaryBg',
          w: '[14.125rem]',
          mt: '[calc(var(--radix-popover-trigger-height) * -1)]',
        }),
      )}
    >
      {mobileNavItems.map((item) => (
        <MenuItem
          key={item.href}
          href={item.href}
          className={flex({ justify: 'space-between', align: 'center' })}
        >
          <span>{item.label}</span>
          <ArrowRightIcon height={16} width={16} />
        </MenuItem>
      ))}
    </Popover>
  );
};
